import { render, staticRenderFns } from "./UserDefinedGroupList.vue?vue&type=template&id=df5a6864&scoped=true"
import script from "./UserDefinedGroupList.vue?vue&type=script&lang=js"
export * from "./UserDefinedGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5a6864",
  null
  
)

export default component.exports